import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import * as L from "leaflet";

type Props = {
  urls: { day: string; sat: string; hybrid: string;};
  onReady?: (ctrl: L.Control.Layers) => void;
};

export const InstallBaseLayers: React.FC<Props> = ({ urls, onReady }) => {
  const map = useMap();

  useEffect(() => {
    const baseOpts: L.TileLayerOptions = {
      tileSize: 256,
      zoomOffset: 0,
      crossOrigin: true,
      updateWhenIdle: true,
      updateWhenZooming: false,
      keepBuffer: 4,
      noWrap: true,
      maxNativeZoom: 18,
    };

    // Base raster layers
    const vector = L.tileLayer(urls.day, baseOpts).addTo(map);
    const sat = L.tileLayer(urls.sat, baseOpts);
    const hybrid = L.tileLayer(urls.hybrid, baseOpts);

    // Layers control (base layers only)
    const ctrl = L.control
      .layers(
        { Vector: vector, Satellite: sat, Hybrid: hybrid },
        undefined,
        { collapsed: true, position: "bottomright" }
      )
      .addTo(map);

    // Collapse the control after switching base layer (optional UX nicety)
    const closeOnBaseChange = () => ctrl.collapse();
    map.on("baselayerchange", closeOnBaseChange);

    // Let parent know when ready
    onReady?.(ctrl);

    // Cleanup
    return () => {
      map.off("baselayerchange", closeOnBaseChange);
      map.removeControl(ctrl);
      [vector, sat, hybrid].forEach((lyr) => map.hasLayer(lyr) && map.removeLayer(lyr));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
